import { render, staticRenderFns } from "./AddonManage.vue?vue&type=template&id=9537e7e4&"
import script from "./AddonManage.vue?vue&type=script&lang=js&"
export * from "./AddonManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports